import React from 'react';
import { useTimer } from 'react-timer-hook';

type Props = {
  time: number;
  onEnd: () => void;
  className?: string;
};

export const CustomCountDown: React.FC<Props> = ({ time, onEnd, className }) => {
  const expiryTimestamp = React.useMemo(() => {
    const date = new Date();
    date.setSeconds(date.getSeconds() + time);
    return date;
  }, [time]);
  const { minutes, seconds } = useTimer({
    autoStart: true,
    expiryTimestamp: expiryTimestamp,
    onExpire: onEnd,
  });

  return (
    <span className={className}>
      {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
    </span>
  );
};
